import React from 'react';

import { Layout } from 'antd';
import Header from './Header';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import InstallApp from '../InstallApp/InstallApp';
import PushReminder from '../Notifications/PushReminder';

type Props = {
  children: any;
};

export default function BaseLayout({ children }: Props) {
  const { t } = useTranslation();
  return (
    <Layout className="layout">
      <a className="skip-link" href="#main-content">{t('mobile.skip')}</a>
      <Header />
      <Layout.Content className="content" id="main-content" tabIndex={-1}>
        <PushReminder />
        {children}
      </Layout.Content>
      <Footer />
      <InstallApp />
    </Layout>
  );
}
